import { useContext } from 'react';
import { ConfigContext } from '../config-provider';
const usePrefixCls = (value, customizePrefixCls) => {
    const { getPrefixCls } = useContext(ConfigContext);
    const prefixCls = getPrefixCls(value, customizePrefixCls);
    return prefixCls;
};
export default usePrefixCls;
